<template>
  <section class="obra-visual-hero obra-dashboard-hero" aria-labelledby="obra-dashboard-title">
    <div class="obra-visual-hero__banner" :style="bannerStyle">
      <div class="obra-visual-hero__overlay"></div>
      <div class="obra-visual-hero__top">
        <span class="obra-tag-age-rating" :style="ageRatingStyle">{{ ageRatingLabel }}</span>
        <div class="obra-dashboard-hero__quick-actions">
          <v-btn icon dark aria-label="Editar obra" @click="$emit('edit-project')">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon dark aria-label="Ver pagina publica" @click="$emit('open-public-page')">
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="obra-visual-hero__body">
      <div class="obra-visual-hero__cover-wrap">
        <img v-if="coverImage" class="obra-visual-hero__cover" :src="coverImage" :alt="coverAlt" @contextmenu.prevent />
        <div v-else class="obra-visual-hero__cover obra-visual-hero__cover--empty" aria-hidden="true">
          <v-icon color="#d9d9d9" size="48">mdi-book-open-page-variant</v-icon>
        </div>
      </div>

      <div class="obra-visual-hero__content">
        <h1 id="obra-dashboard-title" class="obra-visual-hero__title">{{ project.name || 'Obra sem titulo' }}</h1>
        <div v-if="visibleTags.length" class="obra-visual-hero__tags" aria-label="Dados da obra">
          <span v-for="tag in visibleTags" :key="tag" class="obra-visual-hero__tag">{{ tag }}</span>
        </div>
        <div class="obra-dashboard-hero__meta">
          <span><v-icon size="16" color="#d9d9d9">mdi-book-open-page-variant</v-icon>{{ chaptersCount }} capitulos</span>
          <span v-if="project.created_at"><v-icon size="16" color="#d9d9d9">mdi-calendar-plus</v-icon>{{ formatDate(project.created_at) }}</span>
          <span v-if="project.updated_at"><v-icon size="16" color="#d9d9d9">mdi-calendar-clock</v-icon>{{ formatDate(project.updated_at) }}</span>
        </div>
        <p v-if="project.description" class="obra-dashboard-hero__description">{{ project.description }}</p>
        <div class="obra-visual-hero__cta-row">
          <v-btn class="obra-visual-hero__read zinnes-primary-btn" dark rounded large @click="$emit('add-chapter')">
            <v-icon left>mdi-plus</v-icon>
            Adicionar capitulo
          </v-btn>
          <v-btn dark outlined rounded large @click="$emit('edit-project')">
            <v-icon left>mdi-pencil</v-icon>
            Editar obra
          </v-btn>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ObraDashboardHero',
  props: {
    project: { type: Object, required: true },
    chaptersCount: { type: Number, default: 0 },
    tags: { type: Array, default: () => [] },
    ageRatingColor: { type: Function, required: true },
  },
  computed: {
    coverImage() {
      return this.project.thumb || this.project.project_thumb || '';
    },
    bannerImage() {
      return this.project.project_banner || '';
    },
    bannerStyle() {
      return this.bannerImage ? { backgroundImage: `url("${this.bannerImage}")` } : {};
    },
    coverAlt() {
      return `Capa da obra ${this.project.name || ''}`;
    },
    visibleTags() {
      return this.tags.filter(Boolean);
    },
    ageRating() {
      return this.project.age_rating || null;
    },
    ageRatingLabel() {
      return this.ageRating?.rating || 'Livre';
    },
    ageRatingStyle() {
      const age = this.ageRating?.age || 10;
      return { backgroundColor: this.ageRatingColor(age), color: age === 12 ? '#000' : '#fff' };
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const parsedDate = new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return date;

      return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(parsedDate);
    },
  },
};
</script>
